import React from 'react';
import styled from '@emotion/styled';

import ReactTooltip from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck } from '@fortawesome/pro-solid-svg-icons';

import Input from './Input';

const StyledCopyEmailInputContainer = styled.div`
  display:flex;
  flex-direction:row;
  border-right: 0;
  background-image: linear-gradient(-180deg, #F6D365 0%, #FDA085 100%);
  
  padding: 2px;
  border-radius: 4px;
`;

const StyledCopyEmailInput = styled(Input)`
  border: 0;
      min-width: 250px;
`;

const StyledCopyEmailButton = styled.button`
  background-color: transparent;
  color:white;
  border: none;
  padding: 12px;
  :focus {
    outline: none;
  }
  border-radius: 0;
`;

export default ({ onCopy, hasCopied, ...props }) => (
  <StyledCopyEmailInputContainer>
    <StyledCopyEmailInput readonly {...props} />
    <StyledCopyEmailButton onClick={onCopy}>
      <FontAwesomeIcon data-tip="Copied!" className={hasCopied ? 'animated bounceIn' : ''} icon={hasCopied ? faCheck : faCopy} />
    </StyledCopyEmailButton>
    {hasCopied && <ReactTooltip />}
  </StyledCopyEmailInputContainer>
);
